import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { NotificationData } from '../components/notification/notification.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notificationsSubject = new BehaviorSubject<NotificationData[]>([]);
  public notifications$ = this.notificationsSubject.asObservable();

  private notificationId = 0;

  constructor() {}

  /**
   * Mostrar notificación de éxito
   */
  success(title: string, message: string, duration: number = 5000): string {
    return this.show({
      id: this.generateId(),
      type: 'success',
      title,
      message,
      duration,
      showClose: true
    });
  }

  /**
   * Mostrar notificación de error
   */
  error(title: string, message: string, duration: number = 7000): string {
    return this.show({
      id: this.generateId(),
      type: 'error',
      title,
      message,
      duration,
      showClose: true
    });
  }

  /**
   * Mostrar notificación de advertencia
   */
  warning(title: string, message: string, duration: number = 6000): string {
    return this.show({
      id: this.generateId(),
      type: 'warning',
      title,
      message,
      duration,
      showClose: true
    });
  }

  /**
   * Mostrar notificación informativa
   */
  info(title: string, message: string, duration: number = 5000): string {
    return this.show({
      id: this.generateId(),
      type: 'info',
      title,
      message,
      duration,
      showClose: true
    });
  }

  /**
   * Mostrar notificación personalizada
   */
  show(notification: NotificationData): string {
    const currentNotifications = this.notificationsSubject.value;
    this.notificationsSubject.next([...currentNotifications, notification]);
    return notification.id;
  }

  /**
   * Cerrar notificación por ID
   */
  close(notificationId: string): void {
    const currentNotifications = this.notificationsSubject.value;
    const filteredNotifications = currentNotifications.filter(n => n.id !== notificationId);
    this.notificationsSubject.next(filteredNotifications);
  }

  /**
   * Cerrar todas las notificaciones
   */
  closeAll(): void {
    this.notificationsSubject.next([]);
  }

  /**
   * Obtener notificaciones actuales
   */
  getNotifications(): NotificationData[] {
    return this.notificationsSubject.value;
  }

  /**
   * Generar ID único para notificación
   */
  private generateId(): string {
    return `notification-${++this.notificationId}-${Date.now()}`;
  }
}
